import Dexie from "dexie";

export const db = new Dexie("RecapImageDatabase");

// schema
db.version(1).stores({
  logos: "++id, eventId, recapId, name",
});

export default db;
